import React, {useState} from 'react';
import './BuyPremiumButton.css';
import PageButton from '../PageButton/PageButton';
import PremiumTrialModal from '../../Modals/PremiumTrialModal/PremiumTrialModal';

/**
 * Единая кнопка «Купить Премиум» (модалка ежедневных наград, модалка обмена
 * кристаллов): стандартный фон PageButton, слева от надписи иконка премиума
 * (псевдоэлементом — центровка текста не смещается). По нажатию открывает
 * поверх модалку раннего доступа с запросом пробного периода письмом.
 */
function BuyPremiumButton({pageId, buttonId = 'buy_premium', className = ''}) {
  const [showTrialModal, setShowTrialModal] = useState(false);

  return (
    <>
      <PageButton
        className={`buy-premium-button ${className}`}
        onClick={() => setShowTrialModal(true)}
        pageId={pageId}
        buttonId={buttonId}
      >
        Купить Премиум
      </PageButton>

      {showTrialModal && (
        <PremiumTrialModal onClose={() => setShowTrialModal(false)}/>
      )}
    </>
  );
}

export default BuyPremiumButton;
